import React from 'react';
import store from 'store';

import SignUpForm from '../../components/forms/SignUpForm';
import SignupProgress from '../../components/signup/SignupProgress';
import * as SignUpFlow from '../../constants/SignUpFlow';
import * as Path from '../../constants/Path';
import * as Onboarding from '../../analytics/Onboarding';
import StepAbandonmentTracker from '../../analytics/StepAbandonmentTracker';
import '../../components/signup/Signup.scss';


class StepTwo extends React.Component {
  completedRef = { current: false };

  componentDidMount() {
    window.amplitude.getInstance().logEvent('Visited Step 2');
    Onboarding.logVisitedStep(2);

    const signupState = store.get('signupState');
    if (signupState === 'done') {
      this.completedRef.current = true;
      this.props.history.push('/dashboard');
    }
  }

  goToNextStep = () => {
    this.completedRef.current = true;
    if (SignUpFlow.TOTAL_STEPS === 2) {
      this.goToDashboard();
    } else if (SignUpFlow.TOTAL_STEPS === 3) {
      this.goToPaymentStep();
    }
  }

  goToDashboard = () => {
    store.set('signupState', 'done');
    this.props.history.push(Path.DASHBOARD);
  }

  goToPaymentStep = () => {
    store.set('signupState', 'step3');
    this.props.history.push('/start/step3');
  }

  goBackToStepOne = () => {
    this.props.history.push('/start/step1');
  }

  renderAddressSummary() {
    const userInfo = store.get('userInfo');
    if (!userInfo || !userInfo.street1) return null;
    const { fullName, street1, street2, city, state, zipCode } = userInfo;
    return (
      <div className="SignupSummary">
        <div className="SignupSummary__header">
          <span className="SignupSummary__label">Fighting junk mail for</span>
          <button type="button" className="SignupSummary__edit" onClick={this.goBackToStepOne}>
            Edit
          </button>
        </div>
        <p className="SignupSummary__name">{fullName}</p>
        <p className="SignupSummary__address">
          {street1}{street2 ? `, ${street2}` : ''}<br />
          {city}{city && state ? ', ' : ''}{state} {zipCode}
        </p>
      </div>
    );
  }

  render() {
    return (
      <div>
        <div className="container">
          <StepAbandonmentTracker step={2} completedRef={this.completedRef} />
          <SignupProgress currentStep={2} totalSteps={SignUpFlow.TOTAL_STEPS} />
          <h2>One last step</h2>
          <p>We'll email you updates as your opt-out requests go out. No marketing spam.</p>

          {this.renderAddressSummary()}

          <SignUpForm goToNextStep={this.goToNextStep} />
        </div>
      </div>
    );
  }
}

export default StepTwo;
